import update from "immutability-helper"

import {DocumentData, QueryDocumentSnapshot, SnapshotOptions,} from "firebase/firestore"
import Song from "./Song"
import {Account} from "./Account"
import Catalog from "./Catalog"

export default class Session {
    static converter = {
        toFirestore  : (session: Session): DocumentData => {
            return {
                title      : session.title,
                description: session.description,

                playlist: session.playlistKey || null,
                plays   : session.plays,

                openDT : session.openDT || new Date(),
                closeDT: session.closeDT || null
            }
        },
        fromFirestore: (snapshot: QueryDocumentSnapshot<DocumentData>, options?: SnapshotOptions): Session => {
            return new Session(snapshot.id, snapshot.data(options))
        }
    }
    key?: string
    accountPath?: string
    title: string = ''
    description: string = ''
    playlistKey?: string
    plays: string[] = []
    openDT?: Date
    closeDT?: Date

    public constructor(key?: string, data?: DocumentData) {
        if (key && data) {
            this.key = key
            this.title = data.title || ''
            this.description = data.description || ''

            this.playlistKey = data.playlist
            this.plays = data.plays || []

            this.openDT = data.openDT
            this.closeDT = data.closeDT
        }
    }

    public static getSessionsPath(catalog: Catalog): string {
        return catalog.getAccount().getPath() + '/sessions'
    }

    public static getVotesPath(catalog: Catalog): string {
        return catalog.getAccount().getPath() + '/votes'
    }

    public static getPlayersPath(catalog: Catalog): string {
        return catalog.getAccount().getPath() + '/players'
    }

    public setAccount(account: Account) {
        this.accountPath = account.getPath()
    }

    public setTitle(value: string): Session {
        return update(this as Session, {
            title: {
                $set: value
            }
        })
    }

    public setDescription(value: string): Session {
        return update(this as Session, {
            description: {
                $set: value
            }
        })
    }

    public isSongPlayed(song: Song): boolean {
        return this.plays.includes(song.key || '')
    }

    public getPath(): string {
        if (!this.accountPath) {
            throw new Error('no account defined')
        }
        return this.accountPath + '/sessions/' + this.key
    }
}

